import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { RuleService } from '../../../services/rule.service';
import { AlarmStatistics } from '../../../models/alarm-statistics.model';

@Component({
  selector: 'app-active-alarms-card',
  templateUrl: './active-alarms-card.component.html',
  styleUrls: ['./active-alarms-card.component.scss'],
  standalone: false,
})
export class ActiveAlarmsCardComponent implements OnChanges, OnDestroy {
  @Input() filterPayload: any;

  alarmCount: number = 0;
  activeAlarmsFromYesterday: number = 0;
  loading = false;
  private destroy$ = new Subject<void>();

  constructor(
    private ruleService: RuleService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filterPayload']) {
      this.loadAlarmStats();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadAlarmStats(): void {
    if (!this.filterPayload) return;

    this.loading = true;

    this.ruleService
      .GetAlarmStats(this.filterPayload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (stats: AlarmStatistics) => {
          this.alarmCount = stats.alarmCount ?? 0;
          this.activeAlarmsFromYesterday = stats.activeAlarmsFromYesterday ?? 0;
          this.loading = false;
          this.cdr.markForCheck();
        },
        error: (error) => {
          console.error('Error loading alarm statistics:', error);
          this.loading = false;
          this.cdr.markForCheck();
        },
      });
  }
}
